module.exports = __webpack_public_path__ + "img/img2.4552739d.png";